import { FC } from 'react'
import { Route, Redirect, RouteProps } from 'react-router-dom'
import { redirectProductPage } from 'utils/apollo/handleAuthError'
import { isLogin } from 'utils/token'
import { LOGIN_PAGE_PATH } from 'utils/consts/path'
import TableContextProvider from '../../Table/Context/Provider'

const PrivateRoute: FC<RouteProps> = ({ component: Component, ...rest }) => {
  const userLoggedIn = isLogin()
  if (!userLoggedIn) {
    redirectProductPage()

    return (
      <Route
        {...rest}
        render={({ location }) => {
          const state = location?.pathname.includes('/acc/user')
            ? { isLogout: true }
            : { from: location }
          return (
            <Redirect
              to={{
                pathname: LOGIN_PAGE_PATH,
                state,
              }}
            />
          )
        }}
      />
    )
  }

  return (
    <>
      <TableContextProvider>
        <Route {...rest} component={Component} />
      </TableContextProvider>
    </>
  )
}

export default PrivateRoute
